module.exports = __webpack_public_path__ + "static/img/saf2.d67557a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saf2.png
// module id = ysjK
// module chunks = 1